module.exports = __webpack_public_path__ + "static/img/dialog-bg1.3009e1fd.png";